export default {
  subtitle: 'Sleutels authenticeren verzoeken aan de Partner API. Stuur ze mee in de header x-api-key.',
  never_used: 'Nooit gebruikt',
  revoke_confirm: 'Deze sleutel intrekken? Verzoeken hiermee werken direct niet meer.',
  columns: {
    name: 'Naam',
    key: 'Sleutel',
    status: 'Status',
    last_used_at: 'Laatst gebruikt',
    created_at: 'Aangemaakt',
  },
  statuses: {
    active: 'Actief',
    revoked: 'Ingetrokken',
  },
  buttons: {
    create: 'Sleutel aanmaken',
    revoke: 'Intrekken',
  },
  toasts: {
    load_error: 'Kan de API-sleutels niet laden.',
    error: 'Er is iets misgegaan. Probeer het opnieuw.',
    revoked: 'API-sleutel ingetrokken.',
  },
};
